import { useCallback } from 'react';
export var useSearchProps = function (type, disabled, readOnly, value, inputRef, onChange) {
    var searchProps = {};
    var handleIconClick = useCallback(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onChange('');
    }, [inputRef, onChange]);
    if (type === 'search') {
        searchProps.leftIcon = 'search';
        if (!disabled && !readOnly && value) {
            searchProps.rightIcon = 'close';
            searchProps.onRightIconClick = handleIconClick;
        }
    }
    return searchProps;
};
//# sourceMappingURL=use-search-props.js.map